var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7315 22C42.5366 22 44.0249 23.4713 43.7577 25.2566C43.2089 28.9226 41.7396 32.4092 39.4638 35.3797C36.5219 39.2196 32.3964 41.9829 27.7258 43.2418C23.0552 44.5008 18.0998 44.1853 13.6266 42.3442C9.15331 40.503 5.41158 37.2389 2.98041 33.0569C0.549235 28.8749 -0.435837 24.0082 0.177635 19.2099C0.791107 14.4117 2.96892 9.94937 6.37405 6.51356C9.77918 3.07775 14.2218 0.860011 19.0144 0.203534C22.7218 -0.304304 26.4788 0.144061 29.936 1.48119C31.6196 2.13236 32.1618 4.15369 31.2686 5.72237V5.72237C30.3754 7.29106 28.3828 7.80066 26.6616 7.25647C24.4914 6.57032 22.1831 6.3676 19.9015 6.68013C16.533 7.14154 13.4105 8.70031 11.0171 11.1152C8.62381 13.5301 7.09311 16.6665 6.66193 20.039C6.23074 23.4115 6.92311 26.8321 8.63189 29.7715C10.3407 32.7108 12.9706 35.005 16.1146 36.2991C19.2587 37.5932 22.7416 37.8149 26.0244 36.93C29.3072 36.0452 32.2068 34.103 34.2746 31.4041C35.6752 29.576 36.6412 27.4698 37.1188 25.2443C37.4975 23.4793 38.9263 22 40.7315 22V22Z",
    fill: "current"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7237_65491",
    x1: 9.42857,
    y1: 2,
    x2: 41.1429,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D99FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D99FF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoading);
export default __webpack_public_path__ + "static/media/icon-loading.53f797fa.svg";
export { ForwardRef as ReactComponent };